import gql from 'graphql-tag';

import type { FeedAssetGroup } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationMoveAssetGroupToSectionArgs } from 'src/types/backend';

import { FRAGMENT_ASSET_GROUP } from './schema';

const MUTATION = gql`
  mutation MoveAssetGroupToSection($assetGroupId: ID!, $targetSectionId: ID!) {
    moveAssetGroupToSection(assetGroupId: $assetGroupId, targetSectionId: $targetSectionId) {
      ...AssetGroupFields
    }
  }
  ${FRAGMENT_ASSET_GROUP}
`;

export const moveAssetGroupToSection = async (
  variables: BackendMutationMoveAssetGroupToSectionArgs
): Promise<FeedAssetGroup | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<FeedAssetGroup>(response.data);
};
